<template>
    <v-layout justify-center>
        <v-responsive max-width="1280px" width="100%">
            <v-row class="mt-8" justify="center" align="center">
                <v-col cols="auto" class="pt-0 pb-0 headline text-start">
                    {{ `${DDM_WORK_TYPES[this.$route.query.code].text} 스케쥴 목록` }}
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="pt-0 pb-0">
                    <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                </v-col>
            </v-row>

            <v-expand-transition>
                <v-card v-show="showSearch" class="elevation-1 mx-auto">
                    <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6" class="py-0">
                                <v-date-field v-model="filter.createdAt[0]" label="작성일자" persistent-placeholder hide-details></v-date-field>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                                <v-date-field v-model="filter.createdAt[1]" label="작성일자" persistent-placeholder hide-details></v-date-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-3">
                            <v-col cols="6" md="3" class="py-0">
                                <v-select v-model="filter.searchKey" :items="searchKeys" label="검색조건" @change="()=> {filter.searchValue=null; filter.schedule=[]}" hide-details persistent-placeholder></v-select>
                            </v-col>
                            <v-col cols="6" md="3" class="py-0" v-if="[null, 'company', 'equipment', 'quantity'].includes(filter.searchKey)">
                                <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details :disabled="!filter.searchKey"  @keydown.enter="(page = 1) && search()"></v-text-field>
                            </v-col>
                            <v-col cols="6" md="3" class="py-0" v-if="['schedule'].includes(filter.searchKey)">
                                <v-date-field v-model="filter.schedule[0]" label="시작일" hide-details persistent-placeholder></v-date-field>
                            </v-col>
                            <v-col cols="6" md="3" class="py-0" v-if="['schedule'].includes(filter.searchKey)">
                                <v-date-field v-model="filter.schedule[1]" label="종료일" hide-details persistent-placeholder></v-date-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" rounded text @click="(page = 1) && search()"><v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition>
                
            <v-data-table v-bind="{ items: schedules, headers: scheduleHeaders }" disable-sort disable-pagination hide-default-footer class="elevation-1 mt-4">
                <template v-for="header in scheduleHeaders.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                <template #[`item.no`]="{ item }">
                    {{ (page - 1) * limit + (+schedules.indexOf(item) + 1) }}
                </template>
                <template #[`item.schedule`]="{ item }">
                    {{ `${$dayjs(item.scheduleDate).format("YYYY-MM-DD")}`}}
                </template>
                <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt.toDateTime() }}
                </template>
                <template #[`item.actions`]="{item}">
                    <v-icon small @click="edit(item)" title="수정">mdi-pencil</v-icon>
                    <v-icon small @click="remove(item)" title="삭제" class="ml-2">mdi-delete</v-icon>
                </template>
            </v-data-table>
            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12" @input="search()"></v-pagination>
            
            <schedule-calendar/>
            <schedule-create :item="item" @search="search()"/>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { DDM_WORK_TYPES } from "@/assets/variables";

import ScheduleCreate from "@/components/console/schedule/schedule-create.vue";
import ScheduleCalendar from "@/components/console/schedule/schedule-calendar.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";

const scheduleHeaders = [
    { text: "no", align: "center", width: 40, value: "no" },
    { text: "스케쥴", align: "center", width: 100, value: "schedule" },
    { text: "업체명", align: "center", width: 100, value: "company" },
    { text: "사용기기", align: "center", width: 70, value: "equipment" },
    { text: "수량", align: "center", width: 50, value: "quantity" },
    { text: "작성일", align: "center", width: 50, value: "createdAt" },
    { text: "Actions", width: 40, align: "center", value: "actions" },
];
export default {
    components:{
        ScheduleCreate,
        ScheduleCalendar,
        VDateField
    },
    data(){
        return{
            DDM_WORK_TYPES,
            showSearch: true,
            searchKeys: [
                { text: "전체", value: null },
                { text: "업체명", value: "company" },
                { text: "사용기기", value: "equipment" },
                { text: "수량", value: "quantity" },
                { text: "스케쥴", value: "schedule" },
            ],
            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,
            filter: {
                searchKey: this.$route.query.searchKey,
                searchValue: this.$route.query.searchValue,
                createdAt: [(this.$route.query.createdAt || [])[0], (this.$route.query.createdAt || [])[1]],
                schedule: [(this.$route.query.schedule || [])[0], (this.$route.query.schedule || [])[1]],
                code: this.$route.query.code,
            },
            scheduleHeaders,
            item: {},
            schedules: [],
        }
    },
    mounted(){
        this.init();
    },
    methods:{
        init() {
            this.search(false);
        },
        async search(routable = true) {
            try {
                if (routable) {
                    this.$router.push({
                        query: Object.assign({},this.$route.query, this.filter, { page: this.page }),
                    });
                }

                var { summary, schedules } = await api.console.schedule.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.filter,
                });

                this.pageCount = Math.ceil(summary.totalCount / this.limit);
                this.schedules = schedules;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        async remove(schedule){
            try{
                if(confirm("삭제하시겠습니까?")){
                    await api.console.schedule.delete(schedule);
                    await this.search(false);

                    alert("삭제되었습니다.");
                }
                this.search();
            } catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        edit(schedule) {
            this.item = { ...schedule };
        },
    },
    watch:{
        $route(){
            this.search(false);

            Object.assign(this.filter, this.$route.query);
            this.page = +this.$route.query.page || 1;
        }
    }
}
</script>

<style>

</style>